import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { SnackbarService } from 'ok-angular-shared/components';
import { Observable, catchError, map, of } from 'rxjs';
import { ScreeningExpandedStatusEnum } from 'src/app/screening/models/screening-expanded-status.enum';
import { InstallationService } from '../services/installation/installation.service';

@Injectable({
  providedIn: 'root',
})
export class CanActivateInstallationCompleteService implements CanActivate {
  private router = inject(Router);
  private snackbarService = inject(SnackbarService);
  private installationService = inject(InstallationService);

  private screeningStatusInvalidErrorText1 = `OK installationsnr. `;
  private screeningStatusInvalidErrorText2 = ` er ikke færdigscreenet hos OK og kan derfor ikke installeres`;

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const installationNumber = route.params.installationNumber;

    return this.installationService.tryGetScreeningStatusByInstallationNumber(installationNumber).pipe(
      map(screeningStatus => {
        if (this.isScreeningStatusValid(screeningStatus)) {
          return true;
        } else {
          this.router.navigate(['']);
          this.snackbarService.error(this.screeningStatusInvalidErrorText1 + installationNumber + this.screeningStatusInvalidErrorText2, {
            duration: 4000,
          });
          return false;
        }
      }),
      catchError(() => {
        // Fall back to allow access
        return of(true);
      })
    );
  }

  private isScreeningStatusValid(screeningStatus: ScreeningExpandedStatusEnum) {
    // If screening status is unknown (installation has no screening), we always allow installation.
    if (!screeningStatus) {
      return true;
    } else
      return (
        screeningStatus === ScreeningExpandedStatusEnum.AssignedToSubcontractor ||
        screeningStatus === ScreeningExpandedStatusEnum.ApprovedBySubContractor
      );
  }
}
